module.exports = __webpack_public_path__ + "img/Icons - Functional - Chevron right.3400552d.svg";